import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

const OpenBanking = () => {

    useEffect(() => {
      localStorage.setItem('isOpenBanking', true);
    }, [])

    return <Redirect to={'/'} />;
}

export default OpenBanking;


// WEBPACK FOOTER //
// ./src/components/FeedManagment/OpenBanking.js